import React from "react";
import {Alert, Button} from "@mui/material";

/**
 * Explains who will be charged when there is no target yet.
 * Rendered next to the "Mass charge" switch — the place where the target is chosen.
 *
 * idsCount            — result of amountToCharge()
 * isMassCharge        — current mode
 * onEnableMassCharge  — optional; when passed, the hint offers a one-click switch to mass charge
 */
export default function ChargeTargetHint({idsCount, isMassCharge, onEnableMassCharge}) {
    if (idsCount > 0) return null;

    if (isMassCharge) {
        return (
            <Alert severity="info" sx={{mb: 2}}>
                No IDs to charge yet. Paste State IDs below (one per line) or upload a .txt / .csv file,
                then click <b>Validate ids</b>.
            </Alert>
        );
    }

    return (
        <Alert
            severity="info"
            sx={{mb: 2}}
            action={onEnableMassCharge && (
                <Button color="inherit" variant="outlined" onClick={onEnableMassCharge}>
                    Mass charge
                </Button>
            )}
        >
            No user selected. Enter a <b>State ID</b> in the search bar above
            {onEnableMassCharge ? <>, or switch on <b>Mass charge</b> to paste a list of IDs.</> : '.'}
        </Alert>
    );
}
